import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CultureService } from './culture.service';

/**
 * The page's language on every call to the site's API (Multilang_Culture_Spec.md 12.1). A GET carries it as ?lang= - part
 * of the URL, which is what Cloudflare and the server's own response cache key on, so an answer in one language is never
 * handed to another; English sends lang=en too, one rule. Every other call carries the X-Culture header, and its answer is
 * the caller's alone (the server marks it private). A GET that names its own lang (a page asking for a post in another
 * language) keeps it.
 */
@Injectable()
export class CultureInterceptor implements HttpInterceptor {
    constructor(private culture: CultureService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!CultureInterceptor.isApi(req.url)) {
            return next.handle(req);
        }
        if (req.method === 'GET') {
            if (req.params.has('lang') || /[?&]lang=/.test(req.url)) {
                return next.handle(req);
            }
            return next.handle(req.clone({ setParams: { lang: this.culture.lang } }));
        }
        return next.handle(req.clone({ setHeaders: { 'X-Culture': this.culture.lang } }));
    }

    private static isApi(url: string): boolean {
        const base = String(environment.apiUrl || '').replace(/\/+$/, '');
        return url.indexOf(base + '/api/') === 0 || url.indexOf('/api/') === 0;
    }
}
